import React, { useEffect, useContext, useState } from "react";
import { Box } from "@mui/material";
import axios from "axios";
import { AuthContext } from "../contexts/AuthContext";
import SubMenu from "../components/SubMenu";
import NewProduct from "../components/NewProduct";
import ManageProduct from "../components/ManageProduct";
import { databaseMenuOptions } from "../data/database";
import { hasAccess, getTypeOptions } from "../functions";
import { prodApi } from "../data/api";

const dataUrl = prodApi.data;

const DatabaseProducts = ({ maxWidth }) => {
  const { loggedIn, isLoggedIn } = useContext(AuthContext);
  const [products, setProducts] = useState([]);
  const [productsLoaded, setProductsLoaded] = useState(false);
  const [error, setError] = useState("");

  const fetchData = async (
    url,
    params,
    dataLoaded,
    setData,
    setDataLoaded,
    setError
  ) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        setError("Authorization token is missing.");
        return;
      }

      if (dataLoaded) {
        // Data is already loaded; no need to fetch again
        return;
      }

      const response = await axios.get(`${url}/${params}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Process and store the users' data
      setData(response.data);
      setDataLoaded(true);
    } catch (error) {
      console.error("Error fetching users data:", error);
      const message =
        error.response && error.response.status === 403
          ? "You do not have the necessary permissions."
          : "Failed to fetch user data. Please try again later.";
      setError(message);
    }
  };

  // Type Options
  useEffect(() => {
    fetchData(
      dataUrl,
      "products",
      productsLoaded,
      setProducts,
      setProductsLoaded,
      setError
    );
  }, [productsLoaded]);

  const typeOptions = getTypeOptions(products);

  return (
    <>
      {loggedIn &&
        hasAccess(isLoggedIn.accessLevel, ["data", "omni", "admin"]) && (
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                minHeight: "110dvh",
                width: "90%",
                maxWidth: maxWidth,
                zIndex: 0,
                m: "auto",
                p: "auto",
              }}
            >
              <Box
                sx={{
                  mt: 9,
                  fontSize: "2rem",
                  fontWeight: "200",
                }}
              >
                Data Management
              </Box>
              <Box
                sx={{
                  mb: 1.5,
                  fontSize: "1.25rem",
                  fontWeight: "200",
                }}
              >
                Products
              </Box>
              <SubMenu menuOptions={databaseMenuOptions} />

              <Box sx={{ mt: "2rem" }}>
                <ManageProduct
                  header="Manage Products"
                  userId={isLoggedIn.uniqueId}
                  dataUrl={dataUrl}
                />
              </Box>

              <Box sx={{ mt: "2rem" }}>
                <NewProduct
                  dataUrl={dataUrl}
                  userId={isLoggedIn.uniqueId}
                  header="Add New Product"
                  types={typeOptions}
                />
              </Box>

              <Box sx={{ height: "30dvh" }} />
            </Box>
          </Box>
        )}
    </>
  );
};

export default DatabaseProducts;
